//
//
//
//
//

import { METAL_MAP } from '../const'
export default {
    props: {
        medal: String
    },
    computed: {
        icon () {
            return METAL_MAP[this.medal]
        }
    }
}
